var img = "data:image/svg+xml,%3csvg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M16.4363 12.15H0V9.45H16.4363L8.87625 1.89L10.8 0L21.6 10.8L10.8 21.6L8.87625 19.71L16.4363 12.15Z' fill='%23333333' /%3e%3c/svg%3e";

export { img as default };
